import { isAxiosError } from 'axios';

export function formatAiRequestError(err: unknown, cancelledMessage = 'Request cancelled'): string {
  if (isAxiosError(err)) {
    if (err.code === 'ERR_CANCELED' || err.name === 'CanceledError') {
      return cancelledMessage;
    }
    if (err.code === 'ECONNABORTED') {
      return 'Request timed out. Try again or choose a faster model.';
    }
    const status = err.response?.status;
    const serverMsg =
      err.response?.data && typeof err.response.data === 'object' && 'message' in err.response.data
        ? String((err.response.data as { message?: string }).message ?? '')
        : '';
    if (serverMsg.trim()) return serverMsg;
    if (status === 503) {
      return 'AI service unavailable. Check Ollama or API keys in settings.';
    }
    if (status === 403) {
      return 'AI email assistance is disabled for this application.';
    }
    return err.message || 'Request failed';
  }
  if (err instanceof Error && err.name === 'AbortError') {
    return cancelledMessage;
  }
  return err instanceof Error ? err.message : 'Request failed';
}
